import { createFileRoute, redirect } from '@tanstack/react-router';

import { legacySettingsSearch } from '@/pages/settings/settings-tabs';

/**
 * `/teams/:slug/webhooks` is gone as a page (§6 W5-A, Appendix A §9): webhooks
 * live in Team settings › Integrations › Webhooks (rendered by W5-D). Old
 * links and bookmarks land there, on the same team.
 */
export const Route = createFileRoute('/teams/$teamSlug/webhooks')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/settings',
      search: legacySettingsSearch('webhooks', { team: params.teamSlug }),
      replace: true,
    });
  },
});
